/**
 * Demo breed data for development and fallback when APIs are unavailable
 * This provides realistic breed information for testing the matching algorithm
 */

export const demoDogBreeds = [
  {
    id: 1,
    name: "Golden Retriever",
    temperament: "Friendly, Intelligent, Devoted, Trustworthy",
    bred_for: "Retrieving Birds",
    origin: "Scotland",
    life_span: "10 - 12 years",
    weight: { metric: "25 - 32" },
    height: { metric: "51 - 61" },
    reference_image_id: "B1u4l0m4X"
  },
  {
    id: 2,
    name: "French Bulldog",
    temperament: "Playful, Affectionate, Keen, Sociable, Lively, Alert, Easygoing, Patient",
    bred_for: "Lap dog",
    origin: "France",
    life_span: "9 - 11 years",
    weight: { metric: "9 - 12" },
    height: { metric: "30 - 33" },
    reference_image_id: "HyL3UdC4Q"
  },
  {
    id: 3,
    name: "Border Collie",
    temperament: "Tenacious, Keen, Energetic, Responsive, Alert, Intelligent",
    bred_for: "Sheep herder",
    origin: "United Kingdom",
    life_span: "12 - 15 years",
    weight: { metric: "12 - 20" },
    height: { metric: "46 - 56" },
    reference_image_id: "sGQvQUpsp"
  },
  {
    id: 4,
    name: "Cavalier King Charles Spaniel",
    temperament: "Fearless, Affectionate, Sociable, Playful, Patient, Eager",
    bred_for: "Flushing small birds, companion",
    origin: "United Kingdom",
    life_span: "10 - 14 years",
    weight: { metric: "5.9 - 8.2" },
    height: { metric: "30 - 33" },
    reference_image_id: "Sy57D9N47"
  },
  {
    id: 5,
    name: "Poodle",
    temperament: "Intelligent, Active, Alert, Faithful, Trainable, Instinctual",
    bred_for: "Water retrieval",
    origin: "Germany, France",
    life_span: "12 - 15 years",
    weight: { metric: "20 - 32" },
    height: { metric: "45 - 62" },
    reference_image_id: "HNYNQHc4Q"
  }
];

export const demoCatBreeds = [
  {
    id: "abys",
    name: "Abyssinian",
    temperament: "Active, Energetic, Independent, Intelligent, Gentle",
    origin: "Egypt",
    life_span: "14 - 15",
    weight: { metric: "3 - 5" },
    description: "The Abyssinian is easy to care for, and a joy to have in your home. They're affectionate cats and love both people and other animals.",
    energy_level: 5,
    affection_level: 5,
    child_friendly: 3,
    dog_friendly: 4,
    grooming: 1,
    intelligence: 5,
    social_needs: 5,
    hypoallergenic: 0,
    reference_image_id: "0XYvRd7oD"
  },
  {
    id: "ragd",
    name: "Ragdoll",
    temperament: "Docile, Placid, Quiet",
    origin: "United States",
    life_span: "12 - 17",
    weight: { metric: "4 - 9" },
    description: "The Ragdoll is a cat breed with a color point coat and blue eyes. They are large and muscular semi-longhair cats with a soft and silky coat.",
    energy_level: 2,
    affection_level: 5,
    child_friendly: 4,
    dog_friendly: 5,
    grooming: 3,
    intelligence: 3,
    social_needs: 4,
    hypoallergenic: 0,
    reference_image_id: "xnsqonbjW"
  },
  {
    id: "pers",
    name: "Persian",
    temperament: "Affectionate, loyal, Sedate, Quiet",
    origin: "Iran (Persia)",
    life_span: "14 - 15",
    weight: { metric: "3 - 5" },
    description: "A placid cat, the Persian will stay where you put them until you pat them and invite them to play.",
    energy_level: 1,
    affection_level: 5,
    child_friendly: 2,
    dog_friendly: 2,
    grooming: 5,
    intelligence: 3,
    social_needs: 4,
    hypoallergenic: 0,
    reference_image_id: "0B8nswPhS"
  },
  {
    id: "siam",
    name: "Siamese",
    temperament: "Active, Agile, Clever, Sociable, Loving, Energetic",
    origin: "Thailand",
    life_span: "12 - 15",
    weight: { metric: "3 - 5" },
    description: "While Siamese cats are extremely fond of their people, they will follow you around and supervise your every move, being a \"talker\" makes a great pet if you enjoy an interactive, chatty cat.",
    energy_level: 5,
    affection_level: 5,
    child_friendly: 4,
    dog_friendly: 5,
    grooming: 1,
    intelligence: 5,
    social_needs: 5,
    hypoallergenic: 0,
    reference_image_id: "ai6Jps4sx"
  },
  {
    id: "mcoo",
    name: "Maine Coon",
    temperament: "Adaptable, Intelligent, Loving, Gentle, Independent",
    origin: "United States",
    life_span: "12 - 15",
    weight: { metric: "4 - 10" },
    description: "They're big, they're fluffy, they're friendly. What more could you want in a cat?",
    energy_level: 3,
    affection_level: 5,
    child_friendly: 5,
    dog_friendly: 5,
    grooming: 3,
    intelligence: 4,
    social_needs: 3,
    hypoallergenic: 0,
    reference_image_id: "OOD3VXAQn"
  }
];

export const demoImages = {
  // Dog images (placeholder URLs)
  1: "https://images.dog.ceo/breeds/retriever-golden/n02099601_1004.jpg",
  2: "https://images.dog.ceo/breeds/bulldog-french/n02108915_4274.jpg", 
  3: "https://images.dog.ceo/breeds/collie-border/n02106166_372.jpg",
  4: "https://images.dog.ceo/breeds/spaniel-cocker/n02102318_4607.jpg",
  5: "https://images.dog.ceo/breeds/poodle-standard/n02113799_2280.jpg",
  
  // Cat images (placeholder URLs)
  "abys": "https://cdn2.thecatapi.com/images/0XYvRd7oD.jpg",
  "ragd": "https://cdn2.thecatapi.com/images/xnsqonbjW.jpg",
  "pers": "https://cdn2.thecatapi.com/images/0B8nswPhS.jpg",
  "siam": "https://cdn2.thecatapi.com/images/ai6Jps4sx.jpg",
  "mcoo": "https://cdn2.thecatapi.com/images/OOD3VXAQn.jpg"
};